import { useQuery } from '@tanstack/react-query';
import { fetchMonitorReplay } from '@apis/monitor';

const REPLAY_REFRESH_MS = 120_000;

/** One site-local day of replay frames + events. Past days are immutable, so
 *  once fetched they never go stale: going back to one is served from the
 *  cache, with no request. Today (`date === today`, the site's day) refreshes
 *  server-side every 2 min, so it goes stale and refetches on that tick, and
 *  its track advances while the bar stays open; a failure surfaces in the bar
 *  rather than retrying. */
export function useMonitorReplay(siteId: string | undefined, date: string | null, today: string) {
  return useQuery({
    queryKey: ['monitor', 'replay', siteId, date],
    queryFn: ({ signal }) => fetchMonitorReplay(siteId!, date!, signal),
    enabled: !!siteId && !!date,
    staleTime: date === today ? REPLAY_REFRESH_MS : Infinity,
    refetchInterval: date === today ? REPLAY_REFRESH_MS : false,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
